export default __webpack_public_path__ + "static/redux-saga-e7798fbf1ba8cf58efdeea1170785373.png";